<template>
  <div class="flex flex-col justify-between min-h-screen">
    <app-header></app-header>

    <div class="page-wrap">
      <slot></slot>
    </div>

    <app-footer></app-footer>
  </div>
</template>

<script>
export default {
  name: 'app-layout',
};
</script>

<style></style>
